<app-alert [icon]="uiIcon.Warning" *ngIf="!!reviewHistory" class="u-margin-top">
    <p>
        {{
            'ADMIN.DASHBOARD.DETAIL.SURVEYS.HAS_REVIEW'
                | translate : { date: reviewHistory.createdOn | formatDate, interval: reviewHistory.createdOn | timeInterval }
        }}
    </p>
</app-alert>
